export default __webpack_public_path__ + "icon63742d5.png";